import React, { useEffect, useMemo } from 'react';
import { useRoutes } from 'react-router-dom';
import { Notification } from '@qpd-reestr/ui-kit';
import { observer } from 'mobx-react-lite';
import { StoreContext, store } from './store';
import './App.less';
import 'antd/dist/antd.css';
import { useServices } from './hooks';
import { showErrorNotification } from './utils';
import { adminRoutes, anonymousRoutes, commonRoutes, consentRoutes, externalSystemRedirectRoutes, suspiciousActivityRoutes, timeDesynchronizationRoutes, userAuthRoutes } from './routes';

const App: React.FC = () => {

    const services = useServices();

    useEffect(() => {
        (async () => {
            try {
                await services.settingsSerivce.getLinksFromBackend();
            } catch (error : any) {
                showErrorNotification(error.code);
            }
        })();
    }, []);

    // резолвим роуты
    let routes = useMemo(() => {
        // маршруты для неавторизованного пользователя
        if(!store.userStore.isAuthorized)
        {
            return [
                ...commonRoutes,
                ...anonymousRoutes
            ];
        }
    
        if(store.userStore.isSuspiciousActivity)
        {
            return suspiciousActivityRoutes;
        }
    
        if(!store.userStore.hasConsent)
        {
            return consentRoutes;
        }
    
        if(store.userStore.isTimeDesynchronization)
        {
            return timeDesynchronizationRoutes;
        }

        if(store.externalSystemAuthStore.redirectUri)
        {
            return externalSystemRedirectRoutes;
        }
    
        // у админа и оператора одинаковые роуты
        if(store.userStore.isAdmin || store.userStore.isOperator) 
        {
            return [
                ...commonRoutes,
                ...adminRoutes
            ]
        }
    
        return [
            ...commonRoutes,
            ...userAuthRoutes
        ];
    }, [
        store.userStore.isAuthorized, 
        store.userStore.isSuspiciousActivity, 
        store.userStore.hasConsent, 
        store.userStore.isTimeDesynchronization,
        store.externalSystemAuthStore.redirectUri,
        store.userStore.isAdmin,
        store.userStore.isOperator  
    ]);

    return (
        <>
            <StoreContext.Provider value={store}>
                {useRoutes(routes)}
            </StoreContext.Provider>
            <Notification />
        </>
    );
};

export default observer(App);
